window.moreCa = {
    // 河北CA
    hebeica:(function() {
        var hebcaClient
        //初始化
        return {
            initialization: function (obj, callback) {
                import('@/js/ca/hebei/hebcaP11Object2.js')
                import('@/js/ca/hebei/hebeiPDF.js')
                // 创建对象
                var errorStyle = "hebca/html";
                try {
                    hebcaClient = new HebcaClient.HebcaP11Object({
                        debug: false,
                        errorStyle: errorStyle,
                        success:function(){
                            
                            // 获取ca工具版本号
                            var isIE = window.ActiveXObject !== undefined;
                            if(!isIE){// 非ie内核获取ca版本号
                                hebcaClient.readRegB64({
                                    key:'XEhLRVlfQ1VSUkVOVF9VU0VSXFNvZnR3YXJlXEhlYmNhXENsaWVudFg=',
                                    name:'dmVyc2lvbg==',
                                    success: function (val) {
                                        callback(obj)
                                        ReadRegStringB64Example(val)
                                    }
                                })
                            }else{
                                callback(obj)
                            }
                        },
                        fail: function (e) {
                            
                        }
                    });
                    
                }
                catch (e) {
                    console.log(e)
                }
                
            },
            // 签名
            selectSignCert: function (objectVal, callback) {
                var obj = {}
                console.log(hebcaClient)
                hebcaClient.selectSignCert({
                    success: function () {
                        callback(obj)
                    }
                })
            },
            sign: function (objectVal, callback) {
                this.selectSignCert(objectVal, function (obj) {
                   hebcaClient.sign({
                        content: objectVal.character,
                        success: function (signature) {
                            obj.signData = signature; //使用签名证书对随机数签名
                            callback(obj)
                        }
                    })
                })

            },
            // 获取证书对象
            getCertB64: function (objectVal, callback) {
                this.selectSignCert(objectVal, function (obj) {
                    hebcaClient.getCertB64({
                        success: function (cert) {
                            obj.signCert = cert; //获取用户签名证书对象
                            callback(obj)
                        }
                    })
                })
            },
            // 获取有效期
            CAterm: function (objectVal, callback) {
                this.selectSignCert(objectVal, function (obj) {
                    // 获取有效期
                    hebcaClient.getSignCertNotAfter1({
                        success: function (notafter) {
                            obj.dYxq = (new Date(notafter)).Format("yyyy-MM-dd")
                            callback(obj)
                        }
                    })
                })
            },
            // 获取单位名称
            getcadwname: function (objectVal, callback) {
                this.selectSignCert(objectVal, function (obj) {
                    // 获取有效期
                    hebcaClient.getSubjectItem({
                        index: '0',
                        success: function (content) {
                            obj.cadwname = content
                            callback(obj)
                        }
                    })
                })
            },
            // 选择签章
            pdfSelectStamp:function(objectVal,callback){
                SelectStamp(objectVal,function(){
                    
                    callback(success, error, stamp, isSM2)
                })
            },
            // 生成签章结果
            pdfSealHash:function(objectVal,callback){
                SealHash(objectVal.val,objectVal.fun,function(){
                    
                    callback(success, error, result)
                })
            }
        }
    }()),
    // 北京CA
    bjCa: function () {

    }
}

window.useCA = function (level, fs, strategy, callback) {
    return moreCa[level][fs](strategy, callback)
}
